/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface BusinessPartnerModel
 */
export interface BusinessPartnerModel {
  /**
   *
   * @type {string}
   * @memberof BusinessPartnerModel
   */
  Code?: string | null;
  /**
   *
   * @type {string}
   * @memberof BusinessPartnerModel
   */
  Name?: string | null;
  /**
   *
   * @type {string}
   * @memberof BusinessPartnerModel
   */
  TypeCode?: BusinessPartnerModelTypeCodeEnum;
  /**
   *
   * @type {string}
   * @memberof BusinessPartnerModel
   */
  CurrencyCode?: string | null;
}

/**
 * @export
 * @enum {string}
 */
export enum BusinessPartnerModelTypeCodeEnum {
  None = "None",
  Customer = "Customer",
  Vendor = "Vendor",
}
